import { loading } from 'State/actions';
import * as types from './types';

export const getImportResults = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.IMPORT_RESULT_FETCHING, true));

    try {
      const response = await MPWWebApi.getGeneric(`ImportResult`);

      if (response.status === 200) {
        dispatch(saveImportResults(response.data.Data));
      }
    } catch (error) {
      dispatch({
        type: types.IMPORT_RESULT_FETCH_ERROR,
        payload: error,
      });
    }

    dispatch(loading(types.IMPORT_RESULT_FETCHING, false));
  };
};

export const getImportResult = id => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.IMPORT_RESULT_FETCHING, true));

    try {
      const response = await MPWWebApi.getGeneric(`ImportResult/${id}`);

      if (response.status === 200) {
        dispatch(saveImportResult(response.data.Data));
      }
    } catch (error) {
      dispatch({
        type: types.IMPORT_RESULT_FETCH_ERROR,
        payload: error,
      });
    }

    dispatch(loading(types.IMPORT_RESULT_FETCHING, false));
  };
};

const saveImportResult = payload => ({
  type: types.IMPORT_RESULT_SAVE_RESULT,
  payload,
});

const saveImportResults = payload => ({
  type: types.IMPORT_RESULT_SAVE_RESULTS,
  payload,
});



// WEBPACK FOOTER //
// ./src/pages/importresult/state/resultgrid/actions.js